<template>
  <img :src="url" :width="imgWidth" :height="imgHeight" />
</template>

<script setup lang="ts">
const { $isDesktop } = useNuxtApp()

// hosted on cloudinary because current cloudfare config blocks direct requests from outside UK
// having image in public directory would work
const iconUrl = encodeURIComponent(
  'https://res.cloudinary.com/pitchupapi/image/upload/v1755272416/pitchup-map-markerold2_pbaase.png',
)

const props = defineProps<{
  centre: {
    lat: number
    lng: number
  }
  zoom
}>()

const pixelDimensions = $isDesktop ? '376x277' : '180x216'
const [imgWidth, imgHeight] = pixelDimensions.split('x')

const url = computed(() => {
  return `/api/static-map/url-${iconUrl}(${props.centre.lng},${props.centre.lat})/${props.centre.lng},${props.centre.lat},${props.zoom},0,0/${pixelDimensions}@2x`
})
</script>
